module.exports = __webpack_public_path__ + "img/shipment.b3f9dac.svg";